module.exports = __webpack_public_path__ + "static/media/add.9dc6f118.png";